export function getVisitorId(): string {
    if (!navigator.cookieEnabled) {
        return ''
    }

    const mageCacheStorage = JSON.parse(localStorage.getItem('mage-cache-storage') || '{}')

    return mageCacheStorage ? mageCacheStorage['mc-visitor']?.visitorId : ''
}
